import React from "react";
import { IconX } from "@tabler/icons-react";

type IModal = {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
};

const Modal: React.FC<IModal> = ({ open, onClose, children }) => {
  return (
    <div
      onClick={onClose}
      className={
        open
          ? "bg-[#ffffff70] backdrop-blur-md fixed inset-0 w-[100vw] h-[100vh] px-6 md:px-0 flex items-center justify-center z-50"
          : "hidden"
      }
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative max-h-[90svh] w-[500px] bg-white border-2 border-primary-700 rounded-xl shadow-md flex flex-col overflow-hidden"
      >
        <div
          onClick={onClose}
          className="absolute top-2 right-2 rounded-lg cursor-pointer bg-primary-600 p-1 z-10"
        >
          <IconX color="white" size={24} />
        </div>
        <div className="overflow-y-auto p-6 flex-1">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
